export const OPERATOR_TASK_FORM_GROUP = 'operator-task';
